/**
 * Error thrown when an operation exceeds its allowed time limit.
 *
 * This error is used in asynchronous operations to indicate
 * that the operation took too long to complete and was
 * terminated based on a timeout setting.
 */
export class TimeoutError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "TimeoutError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
